export const InrCurrencyFormat = (currency: string) => {

  const formatedNumber = currency.replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
 
  return formatedNumber;
};
